"use client";

import { ArrowDown } from "lucide-react";
import sticker16 from "../../../../public/sticker16.png";
import sticker15 from "../../../../public/sticker15.png";
import SectionTitle from "@/components/shared/SectionTitle";
import PageSection from "@/components/shared/page-section";

type PdfItem = {
	label: string;
	url: string; // URL del singolo PDF
};

type PdfCard =
	| {
			title: string;
			description?: string;
			pdfUrl: string; // per card “semplice”
			cardBg: string;
			accentColor: string;
			items?: never;
	  }
	| {
			title: string;
			items: PdfItem[]; // per card “speciale”
			cardBg: string;
			accentColor: string;
			description?: never;
			pdfUrl?: never;
	  };

const pdfs: PdfCard[] = [
	{
		title: "Modulistica per l'iscrizione alla sezione primavera",
		pdfUrl: "/pdfs/modulistica/1_MOD_AI01_ISCRIZIONE_SEZ.PRIMAVERA_rev.0_2025.pdf",
		description: `Domanda di Iscrizione a.s. 26/27`,
		cardBg: "#fefefe",
		accentColor: "#8b5cf6",
	},
	{
		title: "Modulistica per l'iscrizione alla scuola dell'infanzia",
		pdfUrl: "/pdfs/modulistica/MOD_AI01_ISCRIZIONE_INFANZIA_rev.0_2025.pdf",
		description: `Domanda di Iscrizione a.s. 26/27`,
		cardBg: "#fefefe",
		accentColor: "#ef4444",
	},
	{
		title: "Modulistica per l'iscrizione al servizio doposcuola",
		pdfUrl: "/pdfs/modulistica/MOD_AD01_ISCRIZIONE_DOPOSCUOLA_rev.0_2022.pdf",
		description: `Domanda di Iscrizione a.s. 26/27`,
		cardBg: "#fefefe",
		accentColor: "#22c55e",
	},
	{
		title: "Autocertificazione assenza per motivi personali",
		pdfUrl: "/pdfs/modulistica/Autocertificazione_assenza_motivi_personali.pdf",
		description: "Allegato 1 — rientro a scuola dopo assenza per motivi personali",
		cardBg: "#fefefe",
		accentColor: "#6b7280",
	},
	{
		title: "Autocertificazione assenza per malattia (fino a 5 giorni)",
		pdfUrl: "/pdfs/modulistica/Autocertificazione_assenza_malattia.pdf",
		description:
			"Allegato 2 — dichiarazione sostitutiva per assenze da 3 a 5 giorni",
		cardBg: "#fefefe",
		accentColor: "#6b7280",
	},
];

export default function ModulisticaSection() {
	return (
		<PageSection wide>
			<SectionTitle
				title1="La "
				title2="Modulistica"
				leftIcon={sticker16}
				rightIcon={sticker15}
				iconSizeLeft={150}
				iconSizeRight={150}
				hideIconOnMobile="left"
			/>

			<div className="mt-6 grid grid-cols-1 min-[720px]:grid-cols-3 gap-6 items-stretch w-full">
					{pdfs.map((pdf, index) => {
						const { cardBg, accentColor } = pdf;
						const isSpecial = Array.isArray((pdf as any).items);

						return (
							<div
								key={index}
								className="w-full h-full flex flex-col items-center text-center"
								style={{
									backgroundColor: cardBg,
									borderLeft: `3px solid ${accentColor}`,
									borderRight: `3px solid ${accentColor}`,
								}}
							>
								<div className="p-6 flex flex-col flex-1 w-full">
									<h3
										className={`text-xl font-bold mb-4 min-h-[3.75rem] flex items-center justify-center ${
											isSpecial
												? "h-[70px]"
												: ""
										}`}
										style={{ color: accentColor }}
									>
										{pdf.title}
									</h3>

									{isSpecial ? (
										<div className="space-y-5 flex-1 flex flex-col">
											{(
												pdf as Extract<PdfCard, { items: PdfItem[] }>
											).items.map((item, i) => (
												<div key={i} className="flex flex-col flex-1">
													<p className="min-h-[50px] flex items-center justify-center text-center text-gray-700 text-sm leading-normal mb-3 whitespace-pre-line">
														{item.label}
													</p>
													<a
														href={item.url}
														target="_blank"
														rel="noopener noreferrer"
														className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2 text-md font-semibold text-white rounded-full hover:opacity-90 transition"
														style={{ backgroundColor: accentColor }}
													>
														<ArrowDown className="w-4 h-4" />
														Effettua il download!
													</a>
												</div>
											))}
										</div>
									) : (
										<>
											{pdf.description ? (
												<p className="text-gray-700 text-sm leading-relaxed mb-8 flex-1 whitespace-pre-line">
													{pdf.description}
												</p>
											) : (
												<div className="flex-1" />
											)}
											<a
												href={pdf.pdfUrl}
												target="_blank"
												rel="noopener noreferrer"
												className="mt-auto inline-flex items-center justify-center self-center gap-2 px-4 py-2 text-md font-semibold text-white rounded-full hover:opacity-90 transition"
												style={{ backgroundColor: accentColor }}
											>
												<ArrowDown className="w-4 h-4" />
												Effettua il download!
											</a>
										</>
									)}
								</div>
							</div>
						);
					})}
				</div>
		</PageSection>
	);
}
